"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_router_dom_1 = require("react-router-dom");

var list_1 = __importDefault(require("../../list"));

var detail_1 = __importDefault(require("../../detail"));

var add_1 = __importDefault(require("../../add"));

var data_def_1 = require("../../data-def");

function App(props) {
  var FormUI = props.FormUI,
      ViewUI = props.ViewUI,
      dataDef = props.dataDef;
  var urlPrefix = dataDef.urlPrefix,
      detailUrlPrefix = dataDef.detailUrlPrefix;
  var routes = data_def_1.routesFromPrefix(detailUrlPrefix);
  var linkBack = urlPrefix;
  var Data = props.Data;
  var extra = props.extra;

  var toRoute = function toRoute() {
    var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
    return urlPrefix + r;
  };

  return react_1.default.createElement(react_router_dom_1.Switch, null, react_1.default.createElement(react_router_dom_1.Route, {
    exact: true,
    path: toRoute(routes.add),
    component: function component(props) {
      return react_1.default.createElement(add_1.default, Object.assign({
        UI: FormUI,
        insertPromise: Data.insert,
        linkBack: linkBack
      }, props));
    }
  }), react_1.default.createElement(react_router_dom_1.Route, {
    path: toRoute(routes.detail),
    component: function component(props) {
      return react_1.default.createElement(detail_1.default, Object.assign({
        config: dataDef,
        ViewUI: ViewUI,
        FormUI: FormUI,
        Data: Data,
        extra: extra
      }, props));
    }
  }), react_1.default.createElement(react_router_dom_1.Route, {
    path: toRoute('/'),
    component: function component(props) {
      if (Data.asyncData !== undefined) {
        return react_1.default.createElement(list_1.default, Object.assign({
          asyncData: Data.asyncData,
          dataDef: dataDef,
          addUrl: toRoute(routes.add)
        }, props));
      }

      return react_1.default.createElement(list_1.default, Object.assign({
        dataDef: dataDef,
        dataLoad: Data.list(),
        addUrl: toRoute(routes.add)
      }, props));
    }
  }));
}

exports.default = App;